<template>
  <section class="empty-wrapper">
    <div class="image-box">
      <img :src="emptyInfo.imgUrl" alt="图片">
    </div>
    <span class="font-14 font-w">
      {{emptyInfo.ps}}
    </span>
  </section>
</template>

<script>
export default {
  name: 'cElEmpty',
  components: {},
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {
    emptyInfo () {
      const { name } = this.$route
      const mImg = new Map([
        ['Components', 'electronic_film_empty'],
        ['historyCheck', 'history_check_empty'],
        ['imageBrowsing', 'image_browsing_empty'],
        ['electronicFilm', 'electronic_film_empty'],
        ['permission', 'permission_empty']
      ])
      const mPs = new Map([
        ['Components', '此类型检查没有电子胶片'],
        ['historyCheck', '当前无历史检查'],
        ['imageBrowsing', '此类型检查没有影像'],
        ['electronicFilm', '此类型检查没有电子胶片'],
        ['permission', '您没有浏览权限！']
      ])
      // 根据 url 判断使用哪张图片
      const imgUrl = require('@/assets/images/' + mImg.get(name) + '.png')
      const ps = mPs.get(name)
      const _emptyInfo = {
        imgUrl,
        ps
      }
      return _emptyInfo
    }
  },
  methods: {},
  created () {},
  mounted () {}
}
</script>
